export default __webpack_public_path__ + "static/media/banner4.b42a0cf0.svg";